export default __webpack_public_path__ + "static/media/erin600.f423042a.jpg";